var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 280,
    viewBox: "0 0 163 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.1757 36.1525C76.1757 36.1525 41.5996 37.0227 26.8976 43.3646L28.4439 21.372C28.4439 21.372 31.5198 20.542 31.1032 17.2845C31.0655 16.9983 31.0069 16.7153 30.9278 16.4377C29.8134 12.4744 34.6706 9.15116 28.1972 8.73303C21.7237 8.31489 -5.3287 45.0932 1.30232 59.9752C7.93333 74.8572 50.2993 74.9641 64.5731 70.2627",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M145.155 176.058L73.2491 176.411L82.3342 139.646L55.628 108.433C55.628 108.433 21.7899 138.589 29.5445 189.346C37.299 240.103 139.871 205.207 139.871 205.207L145.158 209.79L145.155 176.058Z",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8702 153.664C60.4541 155.311 45.8467 179.019 45.8467 208.027C45.8467 209.192 45.873 210.346 45.9194 211.493C64.5706 220.597 94.7916 216.471 115.908 211.738C115.961 210.511 115.988 209.274 115.99 208.027C115.99 196.159 113.544 185.18 109.394 176.233L73.2491 176.411L78.8702 153.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M58.8171 103.109C58.8171 103.109 51.7016 219.246 71.7987 274.233L67.6007 280.401H103.346C103.346 280.401 107.251 132.68 107.251 100.797L58.8171 103.109Z",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6792 13.2515V28.3447L68.9819 32.9404V7.46978L87.6792 2.87415V13.2515Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1176 18.4736C77.3937 18.4736 77.6175 18.2498 77.6175 17.9737C77.6175 17.6976 77.3937 17.4738 77.1176 17.4738C76.8415 17.4738 76.6177 17.6976 76.6177 17.9737C76.6177 18.2498 76.8415 18.4736 77.1176 18.4736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7963 18.4736C85.0724 18.4736 85.2962 18.2498 85.2962 17.9737C85.2962 17.6976 85.0724 17.4738 84.7963 17.4738C84.5202 17.4738 84.2964 17.6976 84.2964 17.9737C84.2964 18.2498 84.5202 18.4736 84.7963 18.4736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5435 20.956V13.2515H86.4031",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1758 13.2517H80.0354",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2137 17.1992V19.8747C69.5207 19.8747 68.856 19.5993 68.366 19.1093C67.8759 18.6192 67.6006 17.9546 67.6006 17.2615C67.6006 17.1814 67.6041 17.1021 67.6113 17.0237C67.7577 15.401 70.2137 15.5699 70.2137 17.1992Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2137 19.8746C69.5207 19.8746 68.856 19.5993 68.366 19.1092C67.8759 18.6192 67.6006 17.9545 67.6006 17.2615",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8552 22.8551C80.5079 22.8551 80.164 22.7867 79.8431 22.6538C79.5222 22.5209 79.2307 22.3261 78.9851 22.0805C78.7395 21.8349 78.5447 21.5433 78.4118 21.2225C78.2789 20.9016 78.2104 20.5576 78.2104 20.2103",
    stroke: "#FF6498",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6793 28.3447L68.9819 32.9402",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5431 20.962L80.855 21.3769",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8735 16.3384L66.6631 3.23619L89.868 0.710083L87.6794 8.69964L72.949 10.6383C72.949 10.6383 73.0387 13.9596 71.0103 14.9268L70.2135 16.7479",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.251 59.9678V100.797L49.4111 115.013V69.5405C49.4111 61.7056 52.0381 54.0969 56.8721 47.931C61.706 41.765 68.4678 37.3979 76.0762 35.5279H76.0763C79.7822 34.6171 83.6467 34.5609 87.3775 35.3637C91.1082 36.1665 94.6076 37.8071 97.6109 40.1616C100.614 42.5161 103.043 45.5228 104.713 48.9541C106.383 52.3855 107.251 56.1517 107.251 59.9678V59.9678Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.251 100.797L49.4111 115.013",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8166 103.109C58.8166 103.109 51.7011 219.246 71.7982 274.233",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2959 34.7885C84.2959 34.7885 118.633 30.6425 134.099 34.7885L129.384 13.2517C129.384 13.2517 126.22 12.8758 126.161 9.59229C126.157 9.30369 126.174 9.01517 126.212 8.72907C126.741 4.64617 121.453 2.06132 127.798 0.710141C134.143 -0.641036 166.046 28.6148 161.64 44.3002C157.234 59.9856 115.52 69.4438 100.716 66.8589",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople2);
export default __webpack_public_path__ + "static/media/people-2.47783000f46d286f9f4a2a3ca393c6c8.svg";
export { ForwardRef as ReactComponent };